import { createReducer, on } from '@ngrx/store';
import { HttpError, TransactionStatus } from '@rd/types';
import { RewardsProgramPreference } from '@rd/types/rewards_program.type';
import * as rewardsProgramActions from '../actions/rewards-program-preference.actions';

export interface RewardsProgramPreferenceState {
  rewardsProgramPreference: RewardsProgramPreference;
  rewardsProgramPreferenceLoading: {
    loading: TransactionStatus;
    error: HttpError | null;
  };
}

const initialRewardsProgramPreferenceState: RewardsProgramPreferenceState = {
  rewardsProgramPreference: {
    id: '',
    rewardsProgramId: '',
    userId: '',
  },
  rewardsProgramPreferenceLoading: {
    loading: TransactionStatus.INITIAL,
    error: null,
  },
};
export const rewardsProgramPreferenceReducer = createReducer(
  initialRewardsProgramPreferenceState,
  on(
    rewardsProgramActions.CreateRewardsProgramPreference,
    rewardsProgramActions.GetRewardsProgramPreference,
    (state) => ({
      ...state,
      rewardsProgramPreferenceLoading: {
        loading: TransactionStatus.LOADING,
        error: null,
      },
    }),
  ),
  on(
    rewardsProgramActions.CreateRewardsProgramPreferenceSuccess,
    rewardsProgramActions.GetRewardsProgramPreferenceSuccess,
    (state, { rewardsProgramPreference }) => ({
      ...state,
      rewardsProgramPreference,
      rewardsProgramPreferenceLoading: {
        loading: TransactionStatus.SUCCESS,
        error: null,
      },
    }),
  ),
  on(
    rewardsProgramActions.GetRewardsProgramPreferenceFail,
    (state, { error }) => ({
      ...state,
      rewardsProgramPreferenceLoading: {
        loading: TransactionStatus.FAIL,
        error,
      },
    }),
  ),
);
